export const projects = [
  {
    title: "Social Media App",
    subtitle: "React, HTML and CSS",
    description:
      "A social media application built using React, HTML, CSS, and JavaScript, featuring a user-friendly interface for profile creation, post sharing, media sharing, following, commenting, and liking.",
    image: "./socialmedia.gif",
    link: "https://socialmediareactapp.netlify.app/",
  },
  {
    title: "Netflix Clone UI",
    subtitle: "HTML, CSS and JavaScript",
    description:
      "A Netflix clone front-end built with HTML, CSS, and JavaScript, featuring a user-friendly interface for streaming movie and TV show content",
    image: "./project-2.gif",
    link: "https://reactbootcamp.com",
  },
  {
    title: "DevChat",
    subtitle: "React and Firebase",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./project-3.gif",
    link: "https://reactbootcamp.com",
  },
  {
    title: "Epic Todo App",
    subtitle: "React Hooks",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./project-4.gif",
    link: "https://reactbootcamp.com",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "Java",
  "JavaScript",
  "React",
  "Node",
  "My SQL",
  "MongoDB",
  "Material UI",
];



// WEBPACK FOOTER //
// ./src/data.js